module.exports = __webpack_public_path__ + "static/media/open_arrow.dd11fdf1.svg";